import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import GoalStaticsContainer from '../../containers/goal_statics/GoalStaticsContainer';

const GoalStaticsViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="경영정보/사업목표" icon="statistics" />
      <GoalStaticsContainer />
    </div>
  );
};

export default GoalStaticsViewPage;
